<template>
<div class="chapter">
<div class="inner_page">
<nav epub:type="toc"><h2>Table of Contents</h2>
<ol class="bbb-rw" epub:type="list"><li><a href="#/cover">Cover</a></li>
<li><a href="#/s001BookTitlePage01">Title Page</a></li>
<li><a href="#/s002Copyright01">Copyright</a></li>
<li><a href="#/s004Dedication01">Dedication</a></li>
<li><a href="#/s005Chapter001">Chapter 1: Travis</a></li>
<li><a href="#/s006Chapter002">Chapter 2: Saylor</a></li>
<li><a href="#/s007Chapter003">Chapter 3: Travis</a></li>
<li><a href="#/s008Chapter004">Chapter 4: Saylor</a></li>
<li><a href="#/s010Chapter005">Chapter 5: Travis</a></li>
<li><a href="#/s011Chapter006">Chapter 6: Saylor</a></li>
<li><a href="#/s012Chapter007">Chapter 7: Travis</a></li>
<li><a href="#/s014Chapter008">Chapter 8: Saylor</a></li>
<li><a href="#/s015Chapter009">Chapter 9: Travis</a></li>
<li><a href="#/s016Chapter010">Chapter 10: Saylor</a></li>
<li><a href="#/s017Chapter011">Chapter 11: Travis</a></li>
<li><a href="#/s018Chapter012">Chapter 12: Saylor</a></li>
<li><a href="#/s019Chapter013">Chapter 13: Travis</a></li>
<li><a href="#/s020Chapter014">Chapter 14: Saylor</a></li>
<li><a href="#/s021Chapter015">Chapter 15: Travis</a></li>
<li><a href="#/s022Chapter016">Chapter 16: Saylor</a></li>
<li><a href="#/s023Chapter017">Chapter 17: Travis</a></li>
<li><a href="#/s025Chapter018">Chapter 18: Saylor</a></li>
<li><a href="#/s026Chapter019">Chapter 19: Travis</a></li>
<li><a href="#/s027Chapter020">Chapter 20: Saylor</a></li>
<li><a href="#/s028Chapter021">Chapter 21: Travis</a></li>
<li><a href="#/s029Chapter022">Chapter 22: Saylor</a></li>
<li><a href="#/s031Chapter023">Chapter 23: Travis</a></li>
<li><a href="#/s032Chapter024">Chapter 24: Saylor</a></li>
<li><a href="#/s033Chapter025">Chapter 25: Travis</a></li>
<li><a href="#/s034Chapter026">Chapter 26: Saylor</a></li>
<li><a href="#/s036Chapter027">Chapter 27: Travis</a></li>
<li><a href="#/s037Chapter028">Chapter 28: Saylor</a></li>
<li><a href="#/s038Chapter029">Chapter 29: Travis</a></li>
<li><a href="#/s039Chapter030">Chapter 30: Saylor</a></li>
<li><a href="#/s041Chapter031">Chapter 31: Travis</a></li>
<li><a href="#/s042Chapter032">Chapter 32: Saylor</a></li>
<li><a href="#/s043Chapter033">Chapter 33: Travis</a></li>
<li><a href="#/s044Chapter034">Chapter 34: Saylor</a></li>
<li><a href="#/s045Chapter035">Chapter 35: Travis</a></li>
<li><a href="#/s047Chapter036">Chapter 36: Saylor</a></li>
<li><a href="#/s048Chapter037">Chapter 37: Travis</a></li>
<li><a href="#/s050Chapter038">Chapter 38: Saylor</a></li>
<li><a href="#/s051Chapter039">Chapter 39: Travis</a></li>
<li><a href="#/s052Chapter040">Epilogue: Saylor</a></li>
<li><a href="#/s053Acknowledgments01">Acknowledgments</a></li>
<li><a href="#/s054AboutTheAuthor01">About the Author</a></li>
<li><a href="#/s055AdCard01">Also by Heidi McLaughlin</a></li>
<li><a href="#/s056FrontSales01">Praise</a></li>
<li><a href="#/s057Appendix01">Newsletters</a></li>
</ol></nav>
<nav class="ccc-rw" epub:type="landmarks"><h2>
    Navigation
   </h2>
<ol epub:type="list"><li>
<a epub:type="bodymatter" href="#/s005Chapter001#Chapter41">
      Begin Reading
     </a>
</li>
<li>
<a epub:type="toc" href="#/TOC">
      Table of Contents
     </a>
</li>
</ol></nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TOC.vue?382ed056